import { Icon } from "@abb/abb-common-ux-react";
import React from "react";

{
  /* Toaster notification start */
}

interface IProps {
  toggleToaster: boolean;
  toasterMsg: string;
}

export default class Toaster extends React.Component<IProps, any> {
  render() {
    return (
      this.props.toggleToaster && (
        <div className="toasterMsg">
          <div className="col-2 cols" style={{padding: "7px"}}>
            <Icon name="abb/close" sizeClass="small" />
          </div>
          <div className="col-8 cols">{this.props.toasterMsg}</div>
          <div className="col-2 cols">
          </div>
        </div>
      )
    );
  }
}

{
  /* Toaster notification end */
}
